import React, { createContext, useMemo, useState, ReactNode } from 'react'
import { CurrentUserObject } from '../lib/api/types/user.interfaces'

export interface AuthContextType {
	currentUser: CurrentUserObject | null
	setCurrentUser: (user: CurrentUserObject | null) => void
	mfaEnabled: boolean | null
	setMfaEnabled: (value: boolean) => void
	isAuthenticated: boolean
	isAuthLoading: boolean
	setIsAuthLoading: (value: boolean) => void
}

const AuthContext = createContext<AuthContextType>({
	currentUser: null,
	setCurrentUser: () => { },
	mfaEnabled: null,
	setMfaEnabled: () => { },
	isAuthenticated: false,
	isAuthLoading: true,
	setIsAuthLoading: () => { },
})

export const AuthProvider = ({ children }: { children: ReactNode }) => {
	const [currentUser, setCurrentUser] = useState<CurrentUserObject | null>(null)
	const [mfaEnabled, setMfaEnabled] = useState<boolean | null>(null)
	const [isAuthLoading, setIsAuthLoading] = useState(true)

	const isAuthenticated = Boolean(currentUser?.id)

	const value = useMemo(
		() => ({
			currentUser,
			setCurrentUser,
			mfaEnabled,
			setMfaEnabled,
			isAuthenticated,
			isAuthLoading,
			setIsAuthLoading,
		}),
		[currentUser, isAuthenticated, isAuthLoading, mfaEnabled],
	)

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export default AuthContext
